import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { StateManagment } from "./Context";
import { Toaster } from "react-hot-toast";
import background from "../src/assets/background/background.jpg";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
      <StateManagment>
        <div
          className="relative min-h-screen w-full bg-cover bg-center"
          // style={{ backgroundImage: `url(${background})` }}
        >
          {/* <div className="absolute inset-0 bg-gray-400 bg-opacity-20 backdrop-blur-sm"></div> */}
          <div className="relative z-10">
            <Toaster
              position="top-center"
              reverseOrder={false}
              toastOptions={{
                className: "min-h-[80px] px-4 py-2 text-base flex items-center",
                error: {
                  className:
                    "min-h-[80px] px-4 py-2 text-base flex items-center font-bold",
                },
              }}
            />
            <App />
          </div>
        </div>
      </StateManagment>
    </BrowserRouter>
);

reportWebVitals();

